/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Approval_Aria_LabelInputs */

const en_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve or disapprove event`)
};

const fr_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver ou desapprouver l'evenement`)
};

const de_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis genehmigen oder ablehnen`)
};

const it_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approva o disapprova l'evento`)
};

const ru_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрить или отклонить мероприятие`)
};

const es_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar o desaprobar el evento`)
};

const zh_cn2_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批准或不批准活动`)
};

const ja_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを承認または不承認にする`)
};

const hi_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम को स्वीकृत या अस्वीकृत करें`)
};

const pt_pt2_event_approval_aria_label = /** @type {(inputs: Event_Approval_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovar ou reprovar o evento`)
};

/**
* | output |
* | --- |
* | "Approve or disapprove event" |
*
* @param {Event_Approval_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_approval_aria_label = /** @type {((inputs?: Event_Approval_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Approval_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_approval_aria_label(inputs)
	if (locale === "de") return de_event_approval_aria_label(inputs)
	if (locale === "it") return it_event_approval_aria_label(inputs)
	if (locale === "ru") return ru_event_approval_aria_label(inputs)
	if (locale === "es") return es_event_approval_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_approval_aria_label(inputs)
	if (locale === "ja") return ja_event_approval_aria_label(inputs)
	if (locale === "hi") return hi_event_approval_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_approval_aria_label(inputs)
	return en_event_approval_aria_label(inputs)
});